import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { NbAuthService } from '../auth.service';

@Component({
  selector: 'nb-login',
  template: `
    <nb-auth-block>
      <div style="text-align:center">
        <img src="./assets/images/icon.png" style="width:30%">  
      </div>
      <br>
      <br>
      <h2 class="title">BEFORE YOUR FLIGHT</h2>

      <form (ngSubmit)="login()" #form="ngForm" autocomplete="nope">
        
        <!-- error message -->
        
        <div *ngIf="showMessages.error && errors && !submitted"
             class="alert alert-danger" role="alert">
          <div><strong>Oh snap!</strong></div>
          <div *ngFor="let error of errors">{{ error }}</div>
        </div>
        <!-- success message -->
        <div *ngIf="showMessages.success && messages && !submitted"
             class="alert alert-success" role="alert">
          <div><strong>Hooray!</strong></div>
          <div *ngFor="let message of messages">{{ message }}</div>
        </div>
        <div class="form-group">
          <label for="input-email" class="sr-only">Email address</label>
          <input name="email" [(ngModel)]="user.email" id="input-email" pattern=".+@.+\..+"
                 class="form-control" placeholder="Email address" #email="ngModel"
                 [class.form-control-danger]="email.invalid && email.touched" autofocus
                 [required]="true">
          
          <!-- required message-->
          <small class="form-text error" *ngIf="email.invalid && email.touched && email.errors?.required">
            Email is required!
          </small>
          
          <!-- valid email detection message-->
          <small class="form-text error"
                 *ngIf="email.invalid && email.touched && email.errors?.pattern">
            Email should be the real one!
          </small>

        </div>

        <div class="form-group">
          <label for="input-password" class="sr-only">
            Password
          </label>
          <input name="password" [(ngModel)]="user.password" type="password" id="input-password"
                 class="form-control" placeholder="Password" #password="ngModel"
                 [class.form-control-danger]="password.invalid && password.touched">

          <!-- required message-->          
          <small class="form-text error" *ngIf="password.invalid && password.touched && password.errors?.required">
            Password is required!
          </small>
            
          <small 
            style=" position: absolute; right: 15px; cursor:pointer"
             routerLink="../request-password"
          > 
            Reset password 
          </small>

        </div>

        <br>  
        <br>  
        <button [disabled]="submitted || !form.valid" class="btn btn-block btn-hero-success"
                [class.btn-pulse]="submitted">
          Sign In
        </button>

      </form>
    </nb-auth-block>
  `,
})

export class NbLoginComponent {

  redirectDelay: number = 0;
  showMessages: any = {};

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;

  constructor(protected service: NbAuthService,protected router: Router) {

  }

  login(): void {
    this.errors = [];
    this.showMessages = { error : false };
    this.submitted = true;

    this.service.login(this.user).subscribe(result => {
      this.submitted = false;
      result = result.json();
      console.log(result);
      if (result.success) {
        localStorage.setItem("token",result.token);
        localStorage.setItem("role",result.message.profiltype);
        localStorage.setItem("userid",result.message.userid);
        localStorage.setItem("email",result.message.email);
        localStorage.setItem("firstname",result.message.firstname);
        localStorage.setItem("lastname",result.message.lastname);
        localStorage.setItem("preferedlanguage",result.message.preferedlanguage);
        
        if((result.message.myorganizations).length != 0){

          if(result.message.myorganizations[0]["organization_id"])
            localStorage.setItem("organization_id",result.message.myorganizations[0]["organization_id"]);
          if(result.message.myorganizations[0]["organization_name"])
            localStorage.setItem("organization_name",result.message.myorganizations[0]["organization_name"]);
        
        }
        this.router.navigateByUrl("/dashboard");
      } else {
        this.errors = [ result.message ];
        this.showMessages = { error : true };
      }
      
    },
    err => { console.log(err) }
    );
  }

}
